import React, { useRef, useEffect } from 'react'

const CustomCheckbox = ({ checked, onChange, indeterminate = false, className = '', style = {} }) => {
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  const isChecked = checked && !indeterminate

  return (
    <div
      className={`relative w-[16px] h-[16px] rounded-[4px] flex items-center justify-center flex-shrink-0 transition-colors duration-150 cursor-pointer ${className}`}
      style={{
        background: isChecked ? '#0064E0' : '#fff',
        border: isChecked ? 'none' : '1.5px solid #CED2D9',
        ...style,
      }}
      onClick={onChange}
    >
      {isChecked && (
        <svg
          width="14"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
      {indeterminate && (
        <div className="w-[9px] h-[2px] rounded-sm bg-[#0064E0]" />
      )}
    </div>
  )
}

export default CustomCheckbox
